module.exports = __webpack_public_path__ + "static/media/mymeds_img_2.ba353465.png";